import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useSearchParams, useNavigate} from 'react-router-dom';
// import Card from 'react-bootstrap/Card';
import { Button, Tab, Nav, Modal, Form, Alert, InputGroup } from 'react-bootstrap';
import * as consts from '../consts';

// import SplitPane from 'split-pane-react';
// import 'split-pane-react/esm/themes/default.css';

import MCatalog from './mcatalog';
import MCfilters from './mcfilters';
import MCharts from './mcharts';
import MLeads from './mleads';
import MPeople from './mpeople';
import MLeadDetails from './mleaddetails';
import MLeadFilters from './mleadfitlers';
import MPeopleFilters from './mpeoplefitlers';
import MListFilters from './mlistfilters';
import MFacts from './mfacts';

const CATALOG_TAB = 'catalog';
const LEADS_TAB = 'businesses';
const PEOPLE_TAB = 'people';
const CHARTS_TAB = 'charts';
const DETAILS_TAB = 'details';
const PDETAILS_TAB = 'pdetails';
const FACTS_TAB = 'facts';

function Mmain(props) {
  const SIDE_MIN_WIDTH = '40px';
  const SIDE_MAX_WIDTH = '240px';

  const navigate = useNavigate();
  const linkLocation = useLocation();
  const mcatalogRef = useRef(null);
  const mLeadsRef = useRef(null);
  const mPeopleRef = useRef(null);

  const [sbsplit, setSbsplit] = useState([SIDE_MAX_WIDTH, 'auto']);
  const [vsplit, setVsplit] = useState(["70%", 'auto']);
  const [isAILoading, setIsAILoading] = useState(false)
  const [people, setPeople] = useState([])

  const [thisProps] = useState(props);

  const [showSidebar, setShowSidebar] = useState(true);
  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
    setSbsplit(showSidebar ? [SIDE_MIN_WIDTH, 'auto'] : [SIDE_MAX_WIDTH, 'auto']);
  };

  const [forceResetAll, setForceResetAll] = useState(false);
  const [clearAllVisible, setClearAllVisible] = useState({catalog:false, leads:false, people:false});
  const passClearAllVisible = (tab,status) => {setClearAllVisible((prev) => {prev[tab]= status; return prev; })};
  const showClearAll= ()=>{
    return (
      isCatalogView && clearAllVisible.catalog ||
      isLeadsView && (clearAllVisible.catalog||clearAllVisible.leads))||
      isPeopleView && (clearAllVisible.catalog||clearAllVisible.leads||clearAllVisible.people)
  }

  const [groupByCategory, setGroupByCategory] = useState(false);
  const [showCatalogGridView, setShowCatalogGridView] = useState(true);
  const [showLeadsGridView, setShowLeadsGridView] = useState(true);
  const [showPeopleGridView, setShowPeopleGridView] = useState(true);
  const [forceCatalogRefresh, setForceCatalogRefresh] = useState(false);
  const [forceLeadsRefresh, setForceLeadsRefresh] = useState(false);
  const [forcePeopleRefresh, setForcePeopleRefresh] = useState(false);
  const [forceListFilterRefresh, setForceListFilterRefresh] = useState(false);

  const [activeTab, setActiveTab] = useState(CATALOG_TAB);
  const [activeDetailsTab, setActiveDetailsTab] = useState(CHARTS_TAB);
  const [isCatalogView, setIsCatalogView] = useState(true);
  const [isLeadsView, setIsLeadsView] = useState(false);
  const [isPeopleView, setIsPeopleView] = useState(false);
  const [chartKey, setChartKey] = useState(0);

  //List related variables
  const [leadsInitialGridState, setLeadsInitialGridState] = useState({});
  const passLeadsInitialGridState = (data) => { setLeadsInitialGridState(data) };
  const [peopleInitialGridState, setPeopleInitialGridState] = useState({});
  const passPeopleInitialGridState = (data) => { setPeopleInitialGridState(data) };
  const [listFilters, setListFilters] = useState(null);
  const [selectedList, setSelectedList] = useState(null);
  const updateSelectedList = (data) => (setSelectedList(data));
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [listName, setListName] = useState('');
  const [myListId, setMyListId] = useState(0);

  const [exportingData, setExportingData] = useState(false);
  const passExportingData = (data) => { setExportingData(data) };

  const [updatingChartData, setUpdatingChartData] = useState(false);
  const passUpdatingChartData = (data) => (setUpdatingChartData(data));

  const [updatingMCatalogData, setUpdatingMCatalogData] = useState(false);
  const passUpdatingMCatalogData = (data) => (setUpdatingMCatalogData(data));

  const [mcatalogData, setMCatalogData] = useState([]);
  const updateMCatalogData = (data) => { setMCatalogData(data) };

  const [isUserCategoryGroup, setIsUserCategoryGroup] = useState(() => { return JSON.parse(sessionStorage.getItem('mcfilters-isucg')) || false });
  const passIsUserCategoryGroup = (data) => { setIsUserCategoryGroup(data) };

  const [mcatalogCategoryGroup, setMCatalogCategoryGroup] = useState(() => { return JSON.parse(sessionStorage.getItem('mcfilters-categorygroup')) || null });
  const passMCatalogCategoryGroup = (data) => { setMCatalogCategoryGroup(data) };

  const [mcatalogCategory, setMCatalogCategory] = useState(sessionStorage.getItem('mcfilters-category') || '');
  const passMCatalogCategory = (data) => { setMCatalogCategory(data) };

  const [mcatalogMultipleCategories, setMCatalogMultipleCategories] = useState(sessionStorage.getItem('mcfilters-csvcategories') || '');
  const passMCatalogMultipleCategories = (data) => { setMCatalogMultipleCategories(data) };

  const DEFAULT_COUNTRY = consts.COUNTRIES_DATA[0];
  const [mcatalogCountry, setMCatalogCountry] = useState(sessionStorage.getItem('mcfilters-country-code') || DEFAULT_COUNTRY.code);
  const passMCatalogCountry = (data) => { setMCatalogCountry(data) };

  const [mcatalogState, setMCatalogState] = useState(sessionStorage.getItem('mcfilters-state') || '');
  const passMCatalogState = (data) => { setMCatalogState(data) };

  const [catalogResultsCount, setCatalogResultsCount] = useState(0);
  const passCatalogResultsCount = (data) => { setCatalogResultsCount(data) };

  const [catalogFilter, setCatalogFilter] = useState({});
  const updateCatalogFilter = (data) => { setCatalogFilter(data) };

  const [updatingMLeadDetailsData, setUpdatingMLeadDetailsData] = useState(false);
  const passUpdatingMLeadDetailsData = (data) => (setUpdatingMLeadDetailsData(data));

  const [updatingMLeadsData, setUpdatingMLeadsData] = useState(false);
  const passUpdatingMLeadsData = (data) => (setUpdatingMLeadsData(data));

  const [mleadsData, setMLeadsData] = useState([]);
  const updateMLeadsData = (data) => { setMLeadsData(data) };

  const [leadsResultsCount, setLeadsResultsCount] = useState(0);
  const passLeadsResultsCount = (data) => { setLeadsResultsCount(data) };

  const [peopleResultsCount, setPeopleResultsCount] = useState(0);
  const passPeopleResultsCount = (data) => { setPeopleResultsCount(data) };

  const [leadsFilter, setLeadsFilter] = useState({});
  const updateLeadsFilter = (data) => { setLeadsFilter(data); setPeopleFilter(data); };

  const [leadsFilterModel, setLeadsFilterModel] = useState({});
  const updateLeadsFilterModel = (data) => { setLeadsFilterModel(data); setPeopleFilterModel(data); };

  // const [checkValues, setCheckValues] = useState({});
  // const updateCheckValues = (key, value) => { setCheckValues({ key, value }) };

  const [leadsKeywords, setLeadsKeywords] = useState('');
  const updateLeadsKeywords = (data) => { setLeadsKeywords(data) };

  const [mPeopleData, setMPeopleData] = useState([]);
  const updateMPeopleData = (data) => { setMPeopleData(data) };

  const [updatingMPeopleData, setUpdatingMPeopleData] = useState(false);
  const passUpdatingMPeopleData = (data) => (setUpdatingMPeopleData(data));

  const [peopleFilter, setPeopleFilter] = useState({});
  const updatePeopleFilter = (data) => { setPeopleFilter(data) };

  const [peopleFilterModel, setPeopleFilterModel] = useState({});
  const updatePeopleFilterModel = (data) => { setPeopleFilterModel(data) };

  // const [checkPeopleValues, setCheckPeopleValues] = useState({});
  // const updateCheckPeopleValues = (key, value) => { setCheckPeopleValues({ key, value }) };

  const [updatingMFactsData, setUpdatingMFactsData] = useState(false);
  const passUpdatingMFactsData = (data) => (setUpdatingMFactsData(data));

  const [switchToData, setSwitchToData] = useState({});
  // const [selectedOnly, setSelectedOnly] = useState(false);
  // const updateSelectedOnly = (data) => { setSelectedOnly(data) };

  const [exportingLeadsData,setExportingLeadsData]=useState(false);
  const [exportingPeopleData,setExportingPeopleData]=useState(false);

  const [captchaTriggerPage, setCaptchaTriggerPage] = useState(null);
  const [showCaptcha, setShowCaptcha]= useState(false)
  const [captcha, setCaptcha] = useState(null)
  const [captchaInput, setCaptchaInput] = useState(null)
  const [isCaptchaValid, setIsCaptchaValid] = useState(null)
  const [waitTime, setWaitTime] = useState(0);
  const waitTimeRef = useRef();
  const isCaptchaValidRef = useRef();
  const [hasSelectedIds, setHasSelectedIds] = useState(false);

  const toggleGroup = () => {
    setGroupByCategory(!groupByCategory)
  }

  const toggleCatalogView = () => {
    setShowCatalogGridView(!showCatalogGridView)
  }

  const toggleLeadsView = () => {
    setShowLeadsGridView(!showLeadsGridView)
  }

  const togglePeopleView = () => {
    setShowPeopleGridView(!showPeopleGridView)
  }

  // const toggleSelectedOnly = () => {
  //   setSelectedOnly(!selectedOnly)
  // }

  const joyrideRef = thisProps.joyrideRef;
  const isGuest = sessionStorage.getItem("isGuest") === "true";

  const [searchParams] = useSearchParams();

  useEffect(() => {
    let key = '';
    if (linkLocation.pathname === "/mmain/businesses") {
      setActiveTab(LEADS_TAB);
      key = LEADS_TAB;
    } else if (linkLocation.pathname === "/mmain/people") {
      setActiveTab(PEOPLE_TAB);
      key = PEOPLE_TAB;
    } else{
      setActiveTab(CATALOG_TAB);
      key = CATALOG_TAB;
    }

    setShowSidebar((key === CATALOG_TAB) || (key === LEADS_TAB) || (key === PEOPLE_TAB));
    setIsCatalogView(key === CATALOG_TAB);
    setIsLeadsView(key === LEADS_TAB);
    setIsPeopleView(key === PEOPLE_TAB);
    setLeadsKeywords('');
    setActiveDetailsTab(key === CATALOG_TAB ? CHARTS_TAB : DETAILS_TAB);

    const linkLocationListId = parseInt(linkLocation.state?.listId ?? 0);
    setMyListId(linkLocationListId)
  }, [linkLocation.pathname]);

  // useEffect(() => {
  //   const linkLocationTab = linkLocation.state?.tab ?? 0;
  //   const linkLocationListId = parseInt(linkLocation.state?.listId ?? 0);
  //   handleTabSelection([CATALOG_TAB, LEADS_TAB, PEOPLE_TAB][linkLocationTab]);
  //   // setSelectedOnly(linkLocationTab === CATALOG_TAB);
  //   setMyListId(linkLocationListId)
  // }, [linkLocation.pathname, linkLocation.state])

  const handleTabSelection = (key) => {
    const path=`/mmain/${key === CATALOG_TAB ? '' : key}`;
    navigate(path);

  };

  useEffect(() => {
    sessionStorage.setItem('activeTab', activeTab);

    const updateStatus = async () => {
      try {
        const userid = thisProps.uid;
        const { data } = await axios.get(`/quicktipstatus/${userid}`);

        const statusKeyMap = {
          catalog: 'iscatalogtourcompleted',
          businesses: 'isleadstourcompleted',
          people: 'ispeopletourcompleted',
        };

        const key = statusKeyMap[activeTab];

        if (key in data) {
          const statusValue = Number(data[key]); // force to number

          if (statusValue === 0) {
            joyrideRef.current?.startTour(activeTab);
          }
        } else {
          console.warn(`Key ${key} not found in API response`);
        }

      } catch (error) {
        console.error('Error updating quick tip status:', error);
      }
    };

    updateStatus();
  }, [activeTab, thisProps.uid]);



  const handleDetailsTabSelection = (key) => {
    setActiveDetailsTab(key)
  }

  const handlPeopleAIButton = async () => {

    setIsAILoading(true)

    const postdata = {
      country: mcatalogCountry.toLowerCase(),
      domainid: mleadsData[0].id,
      homeurl: 'https://' + mleadsData[0].tld,
      teamurl: mleadsData[0].leadershipurl,
      abouturl: mleadsData[0].abouturl
    }

    const response = await axios.post('/extractPeopleAI', postdata)
    // console.log("AI people",response.data)
    setPeople(response.data)

    setIsAILoading(false)
  }

  const switchToList = (data) => {
    setSwitchToData(data);
    // setSelectedOnly(true);
    handleTabSelection(LEADS_TAB);
  }

  const tabRefresh = () => {
    if (activeTab === CATALOG_TAB) {
      setForceCatalogRefresh(!forceCatalogRefresh)
    } else if (activeTab === LEADS_TAB) {
      setForceLeadsRefresh(!forceLeadsRefresh)
    } else if (activeTab === PEOPLE_TAB) {
      setForcePeopleRefresh(!forcePeopleRefresh)
    }
  }

  useEffect(() => {
    mcatalogRef.current?.toggleGroup(!groupByCategory);
  }, [groupByCategory]);

  useEffect(() => {
    mcatalogRef.current?.toggleView(!showCatalogGridView);
  }, [showCatalogGridView]);

  useEffect(() => {
    mLeadsRef.current?.toggleView(!showLeadsGridView);
  }, [showLeadsGridView]);

  useEffect(() => {
    mPeopleRef.current?.toggleView(!showPeopleGridView);
  }, [showPeopleGridView]);

  useEffect(() => {
    if (isCatalogView && !updatingMCatalogData) {
      mcatalogRef.current?.fetchData();
      setChartKey(Math.random());
    }
  }, [activeTab, forceCatalogRefresh, isUserCategoryGroup, mcatalogCategoryGroup, mcatalogCategory, mcatalogMultipleCategories, mcatalogCountry, mcatalogState, groupByCategory]);

  useEffect(() => {
    if (isLeadsView) {
      setLeadsFilter({ index: 1, value: 0 })
    } else if (isPeopleView) {
      setPeopleFilter({ index: 1, value: 0 })
    }
  }, [activeTab])

  useEffect(() => {
    if (isLeadsView && !updatingMLeadsData) {
      mLeadsRef.current?.fetchData();
      setChartKey(Math.random());
    }
  }, [activeTab, forceLeadsRefresh, isUserCategoryGroup, mcatalogCategoryGroup, mcatalogCategory, mcatalogMultipleCategories, mcatalogCountry, mcatalogState, leadsKeywords]); // , selectedOnly

  useEffect(() => {
    mLeadsRef.current?.applyFilter(leadsFilter)
  }, [leadsFilter]);

  useEffect(() => {
    mLeadsRef.current?.applyFilterModel(leadsFilterModel);
  }, [leadsFilterModel]);

  useEffect(() => {
    if (isPeopleView && !updatingMPeopleData) {
      mPeopleRef.current?.fetchData();
      setChartKey(Math.random());
    }
  }, [activeTab, forcePeopleRefresh, isUserCategoryGroup, mcatalogCategoryGroup, mcatalogCategory, mcatalogMultipleCategories, mcatalogCountry, mcatalogState, leadsKeywords]); // , selectedOnly

  useEffect(() => {
    mPeopleRef.current?.applyFilter(peopleFilter)
  }, [peopleFilter]);

  useEffect(() => {
    mPeopleRef.current?.applyFilterModel(peopleFilterModel)
  }, [peopleFilterModel]);

  function resetFilterModel() {
    setForceResetAll(!forceResetAll)
  }

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const handleResize = (e) => {
      if (e.matches) {
        setShowSidebar(false); // auto-collapse on small screens
      } else {
        setShowSidebar(true);  // show on large screens
      }
    };

    // Set initial value
    handleResize(mediaQuery);

    // Add listener
    mediaQuery.addEventListener('change', handleResize);

    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);


  useEffect(() => {
    async function getPeople(country) {
      const mleadsDataId = (mleadsData && mleadsData.length > 0) ? mleadsData[0].id : -1;
      try {
        const response = await axios.get(`/getPeople/${country}/${mleadsDataId}`)
        setPeople(response.data)
      } catch (error) {
        console.log(error)
      }
    }

    getPeople(mcatalogCountry ?? DEFAULT_COUNTRY.code)
  }, [mleadsData[0]?.id])

  useEffect(() => {
    if (showCaptcha) {
      waitTimeRef.current = setInterval(()=>{
        setWaitTime((remaining_sec)=>{
          if(remaining_sec<1){
            clearInterval(waitTimeRef.current)
            if(isCaptchaValidRef.current){
              handleCaptchaSuccess()
            }
            return 0
          }
          return remaining_sec-1
        })
      }, 1000)
    } else
      clearInterval(waitTimeRef.current)
    return () => clearInterval(waitTimeRef.current)
  }, [showCaptcha]);


  const changeListName = (e) => {
    setListName(e.target.value)
  }

  const startSave = () => {
    setListName(selectedList?.label ?? '');
    setShowSaveModal(true)
  }

  const cancelSave = () => {
    setShowSaveModal(false)
  }

  const isNewList = () => {
    return (listName.trim() !== '') && (listName.trim().toLowerCase() !== (selectedList?.label ?? '').trim().toLowerCase())
  }

  const saveNewList = () => {
    setShowSaveModal(false);
    saveGridState(true);
  }

  const saveList = () => {
    setShowSaveModal(false);
    saveGridState(false);
  }

  const selection = isLeadsView ? mLeadsRef.current?.getSelectionState() : isPeopleView   ? mPeopleRef.current?.getSelectionState()   : null;

  const saveGridState = async (isNew) => {
    const gridApi = isLeadsView ? mLeadsRef.current?.gridRef.current?.api : isPeopleView ? mPeopleRef.current?.gridRef.current?.api : null;
    const columnApi = isLeadsView ? mLeadsRef.current?.gridRef.current?.columnApi : isPeopleView ? mPeopleRef.current?.gridRef.current?.columnApi : null;
    const listType = isLeadsView ? 1 : isPeopleView ? 2 : 0;

    try {
      const filterCatalogData = mcatalogData;
      const filterIsUserCategoryGroup = isUserCategoryGroup;
      const filterCategoryGroup = mcatalogCategoryGroup;
      const filterMultipleCategories = mcatalogMultipleCategories;
      const filterCategory = mcatalogCategory;
      const filterCountry = mcatalogCountry;
      const filterState = mcatalogState;
      const filterKeywords = leadsKeywords;

      const gridState = JSON.stringify({
        columnState: columnApi.getColumnState(),
        groupState: columnApi.getColumnGroupState?.(),
        columnDefs: gridApi.getColumnDefs(),
        filterModel: gridApi.getFilterModel(),

        filterCatalogData,
        filterIsUserCategoryGroup,
        filterCategoryGroup,
        filterMultipleCategories,
        filterCategory,
        filterCountry,
        filterState,
        filterKeywords,
        resultsCount: isLeadsView ? leadsResultsCount : isPeopleView ? peopleResultsCount : 0,
      })

      if (isNew) {
        axios.post(`/newlist`, { name: listName, state: gridState, userid: thisProps.uid, type: listType, selection:selection })
          .then(res => {
            setForceListFilterRefresh(!forceListFilterRefresh);
            alert("List saved successfully");
          })
          .catch((error) => {
            throw (error)
          })
      } else {
        axios.post(`/updatelist`, { id: selectedList.value, name: listName, state: gridState, selection:selection })
          .then(res => {
            setForceListFilterRefresh(!forceListFilterRefresh);
            alert("List saved successfully");
          })
          .catch((error) => {
            throw (error)
          })
      }
      setForceListFilterRefresh(prev => !prev);
      if (isLeadsView) { mLeadsRef.current?.clearSelection(); }
      if (isPeopleView) { mPeopleRef.current?.clearSelection(); }
    } catch (err) {
      console.log(err)
      alert('Error while saving the list')
    }
  };

  useEffect(() => {
    async function applyGridState() {
      if (isLeadsView) {
        setUpdatingMLeadsData(true)
      } else if (isPeopleView) {
        setUpdatingMPeopleData(true)
      }
      await loadGridState(selectedList?.value ?? 0);
      if (isLeadsView) {
        setUpdatingMLeadsData(false)
      } else if (isPeopleView) {
        setUpdatingMPeopleData(false)
      }
    }

    setListName(selectedList?.label ?? '');
    applyGridState();
  }, [selectedList])

  // On initial load, check URL parameters for scg, ucg, and country to set filters
  useEffect(() => {
    async function applyUrlFilters() {

      const cg = decodeURIComponent(searchParams.get("categorygroup")??''); 
      const ucg = decodeURIComponent(searchParams.get("ucg")??''); 
      let country = decodeURIComponent(searchParams.get("country")??'');

      if(cg!==''||ucg!==''){

        country= country!==''?country:'US';
        const isUserCategoryGroup=ucg!=='';


        const response= await axios.get(isUserCategoryGroup?`/usercategorygroups` : '/categorygroups'); 
        const categoryGroups=response.data;
        const categorygroup=categoryGroups.filter(c=>c.label.trim().toLowerCase()=== (isUserCategoryGroup?ucg:cg).trim().toLowerCase())[0]??null;

        setListFilters({
          filterIsUserCategoryGroup: isUserCategoryGroup,
          filterCategoryGroup: categorygroup,
          filterCountry: country.toUpperCase(),
          filterMultipleCategories: '',
          filterCategory: '',
          filterState: '',
          filterKeywords: '',
        });


        // Wait for all changes to be propagated
        setTimeout(() => {
          mcatalogRef.current?.fetchData()
        }, 2000)
      }
    }
    applyUrlFilters();
  },[])

  const loadGridState = async (listId) => {
    return await new Promise((resolve, reject) => {
      const gridApi = isLeadsView ? mLeadsRef.current?.gridRef.current?.api : isPeopleView ? mPeopleRef.current?.gridRef.current?.api : null;
      const columnApi = isLeadsView ? mLeadsRef.current?.gridRef.current?.columnApi : isPeopleView ? mPeopleRef.current?.gridRef.current?.columnApi : null;

      if (listId > 0) {
        axios.get(`/getlist/${listId}`)
          .then(res => {
            if (res && res.data && res.data[0].state) {
             const payload = {
                  listid: res.data[0].id,
                  selectedIds: res.data[0].selectedids ? res.data[0].selectedids.split(',').map(Number) : [],
                };
                
                if (isLeadsView && mLeadsRef.current) {
                  mLeadsRef.current.setCustomListInfo(payload);
                }

                if (isPeopleView && mPeopleRef.current) {
                  mPeopleRef.current.setCustomListInfo(payload);
                }

                setHasSelectedIds(payload.selectedIds.length > 0);

              const type = res.data[0].type;
              const gridState = JSON.parse(res.data[0].state);
              if (gridApi && columnApi) {
                gridApi.setColumnDefs(gridState.columnDefs);
                columnApi.applyColumnState({ state: gridState.columnState, applyOrder: true });
                columnApi.setColumnGroupState?.(gridState.groupState);
                gridApi.ensureIndexVisible(0, 'top');
              }

              setMCatalogData(gridState.filterCatalogData);
              setListFilters({
                filterIsUserCategoryGroup: gridState.filterIsUserCategoryGroup,
                filterCategoryGroup: gridState.filterCategoryGroup,
                filterMultipleCategories: gridState.filterMultipleCategories,
                filterCategory: gridState.filterCategory,
                filterCountry: gridState.filterCountry,
                filterState: gridState.filterState,
                filterKeywords: gridState.filterKeywords,
              });

              if (type === 1) {
                setLeadsFilterModel(gridState.filterModel)
              } else if (type === 2) {
                setPeopleFilterModel(gridState.filterModel)
              }
            }
          })
          .catch((error) => {
            throw (error)
          })
      } else {
        if (gridApi && columnApi) {
          const initialGridState = isLeadsView ? leadsInitialGridState : isPeopleView ? peopleInitialGridState : null;
          const payload = { selectedIds: new Set()};
          setHasSelectedIds(false);
          if (isLeadsView) { mLeadsRef.current?.setCustomListInfo(payload); }
          if (isPeopleView) { mPeopleRef.current?.setCustomListInfo(payload); }

          if (initialGridState) {
            gridApi.setColumnDefs(initialGridState.columnDefs);
            columnApi.applyColumnState({ state: initialGridState.columnState, applyOrder: true });
            columnApi.setColumnGroupState?.(initialGridState.groupState);
            gridApi.ensureIndexVisible(0, 'top');
          }
        }
        setListFilters(null);
        if (isLeadsView) {
          setLeadsFilterModel({});
        } else if (isPeopleView) {
          setPeopleFilterModel({});
        }
      }
      // Wait for all changes to be propagated
      setTimeout(() => {
        if (isLeadsView) {
          mLeadsRef.current?.fetchData()
        } else if (isPeopleView) {
          mPeopleRef.current?.fetchData()
        }
        resolve()
      }, 2000)
    })
  }

  const exportBusinesses = async () => {
    mLeadsRef.current.exportLeads(false)
  }

  const exportBusinessesPeople = async () => {
    mLeadsRef.current.exportLeads(true)
  }

  const exportPeople = async () => {
    mPeopleRef.current.exportPeople()
  }

  const updatingData = () => {
    return (updatingMCatalogData || updatingMLeadsData || updatingMPeopleData)
  }

  const triggerCaptcha =(remainingseconds, page)=>{ 
    setShowCaptcha(true);
    generateCaptcha();
    setWaitTime(remainingseconds);
    setCaptchaTriggerPage(page);
  }

  const generateCaptcha = async()=>{
    try{
      const response = await axios.get('/generatecaptcha');
      setCaptcha(response.data)
    }
    catch(error){
      console.error(error);
    }
  }

  const verifyCaptcha = async ()=>{
    try{
      const response = await axios.post('/verifycaptcha', {captcha:captchaInput});
      setIsCaptchaValid(response.data.success);
      isCaptchaValidRef.current = response.data.success;
      if(!response.data.success){
        setCaptchaInput('')
         setInterval(await generateCaptcha(),5000);
        setIsCaptchaValid(false);
      }
      if(response.data.success && waitTime===0){
        handleCaptchaSuccess();
      }
    }
    catch(error){
      console.error(error);
    }
  }

  const handleCaptchaSuccess=()=>{
            const useRef = captchaTriggerPage.toLowerCase().trim()==='leads'? mLeadsRef : mPeopleRef;
    useRef.current.getRows(useRef.current.paramRef.current);
    setShowCaptcha(false)
    setCaptchaInput('')
    setIsCaptchaValid(null)
            isCaptchaValidRef.current=false
  }

  return (
    <React.Fragment>
      <div className="d-flex flex-row w-100 h-100 catalog-step1">
        <div className={`${showSidebar ? 'd-flex' : 'd-none'} flex-column border shadow filter-sidebar`} style={{ cursor: updatingData() ? "wait" : "default" }}>
          <div className='w-100 p-0 d-flex align-items-center bg-primary text-white shadow' style={{ height: '40px', pointerEvents: updatingData() ? "none" : "auto" }}>
            <span className={`w-100 p-2 fs-5 fw-bold`}>Filter</span>
            <div className="ms-auto">
              <Button title="Filters" className={`mx-1`} onClick={() => setShowSidebar(false)}>
                <i className={`bi bi-x`}></i>
              </Button>
            </div>
          </div>
          <div className={`w-100 p-2 side-panel overflow-auto`} style={{ pointerEvents: updatingData() ? "none" : "auto" }}>
            {isLeadsView ? (<>
              <MListFilters myListId={myListId} mode={LEADS_TAB} loggedInUserPlan={thisProps.plan} listRefresh={forceListFilterRefresh} pmlsl={updateSelectedList} loggedInUserId={thisProps.uid} />
            </>) : ''}
            {isPeopleView ? (<>
              <MListFilters myListId={myListId} mode={PEOPLE_TAB} loggedInUserPlan={thisProps.plan} listRefresh={forceListFilterRefresh} pmlsl={updateSelectedList} loggedInUserId={thisProps.uid}/>
            </>) : ''}
            <div className={`mx-1 my-1 justify-content-end ${showClearAll() ?  'd-flex' : 'd-none'}`} style={{color: "#ff3f6c", fontWeight: "700", fontSize: "13px", cursor: "pointer"}} onClick={resetFilterModel}>CLEAR ALL</div>
            <MCfilters loggedInUserPlan={thisProps.plan} loggedInUserId={thisProps.uid} listFilters={listFilters} groupByCategory={groupByCategory} switchToData={switchToData} pmisucg={passIsUserCategoryGroup} pmccg={passMCatalogCategoryGroup} pmcco={passMCatalogCountry} pmcca={passMCatalogCategory} pmcmc={passMCatalogMultipleCategories} pmcst={passMCatalogState} forceReset={forceResetAll} pcav={passClearAllVisible} disableCountry={hasSelectedIds} />
            {isPeopleView ? (<>
              <MPeopleFilters loggedInUserPlan={thisProps.plan} listFilters={listFilters} groupByCategory={groupByCategory} catalog={mcatalogData} country={mcatalogCountry} peopleFilterModel={peopleFilterModel} pmcco={passMCatalogCountry} pplfm={updatePeopleFilterModel} forceReset={forceResetAll} pcav={passClearAllVisible} /> {/* selectedOnly={selectedOnly} */}
            </>) : ''}
            {isLeadsView || isPeopleView ? (<>
              <MLeadFilters loggedInUserPlan={thisProps.plan} listFilters={listFilters} groupByCategory={groupByCategory} catalog={mcatalogData} country={mcatalogCountry} leadsFilterModel={leadsFilterModel} pmcco={passMCatalogCountry} pmlfm={updateLeadsFilterModel} pmlkw={updateLeadsKeywords} forceReset={forceResetAll} pcav={passClearAllVisible} /> {/* selectedOnly={selectedOnly} */}
            </>) : ''}
          </div>
        </div>
        <div className='d-flex flex-row flex-grow-1 h-100 m-0 p-0'>
          <div className='col-12 col-lg-8 m-0 p-0 flex-grow-1' style={{ height: "calc(100% - 43px)" }}>
            <Tab.Container defaultActiveKey={CATALOG_TAB} onSelect={handleTabSelection} activeKey={activeTab}>
              <Nav variant='tabs' className='m-0 p-0 fs-6 d-flex flex-row' >
                <div className="my-auto">
                  <Button title="Filters" className={`mx-1 ${showSidebar ? 'd-none' : 'd-block'}`} onClick={() => setShowSidebar(true)}>
                    <i className={`bi bi-filter`}></i>
                  </Button>
                </div>
                <Nav.Item className={`catalog-step3 ${(activeTab!==CATALOG_TAB) ? 'd-none':''}`}><Nav.Link eventKey={CATALOG_TAB}>Catalog{updatingMCatalogData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse text-white"></i></React.Fragment>) : ''}</Nav.Link></Nav.Item>
                <Nav.Item className={`business-step1 ${(activeTab!==LEADS_TAB) ? 'd-none':''}`}><Nav.Link eventKey={LEADS_TAB}>Businesses{updatingMLeadsData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse text-white"></i></React.Fragment>) : ''}</Nav.Link></Nav.Item>
                <Nav.Item className={`people-step1 ${(activeTab!==PEOPLE_TAB) ? 'd-none':''}`}><Nav.Link eventKey={PEOPLE_TAB}>People{updatingMPeopleData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse text-white"></i></React.Fragment>) : ''}</Nav.Link></Nav.Item>
                <div className="ms-auto py-1 d-flex flex-row justify-content-end align-items-center">
                  {/* (isLeadsView || isPeopleView) ? (
                    <Nav.Item>
                      <Button className={`me-1 float-right text-truncate`} variant="outline-primary" style={{ maxWidth: '200px' }} title={selectedOnly ? groupByCategory ? mcatalogData.state ?? '' : mcatalogData.category_en ?? '' : ''}>
                        <i className={`bi ${groupByCategory ? 'bi-globe-americas' : 'bi-columns-gap'}`}></i>{selectedOnly ? '  '.concat(groupByCategory ? mcatalogData.state ?? '' : mcatalogData.category_en ?? '') : ''}
                      </Button>
                    </Nav.Item>
                  ) : '' */}
                  {(isCatalogView && (catalogResultsCount > 0)) ? (
                    <Nav.Item>
                      <Button className={`me-1 float-right`} variant="outline-primary">{updatingMCatalogData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse"></i></React.Fragment>) : `Count: ${parseInt(catalogResultsCount).toLocaleString()}`}</Button>
                    </Nav.Item>
                  ) : ''}
                  {((isLeadsView && leadsResultsCount > 0) || (isPeopleView && peopleResultsCount > 0)) ? (
                    <Nav.Item>
                      <Button className={`me-1 float-right`} variant="outline-primary">{(isLeadsView ? updatingMLeadsData : updatingMPeopleData) ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse"></i></React.Fragment>) : `Count: ${parseInt(isLeadsView ? leadsResultsCount : isPeopleView ? peopleResultsCount : 0).toLocaleString()}`}</Button>
                    </Nav.Item>
                  ) : ''}
                  {isCatalogView ? (<>
                    <Nav.Item>
                      <Button title="Category / State" className={`me-1 float-right catalog-step5`} onClick={toggleGroup}><i className={`bi ${groupByCategory ? 'bi-columns-gap' : 'bi-globe-americas'}`}></i></Button>
                    </Nav.Item>
                    <Nav.Item>
                      <Button title="Grid / Cards" className={`me-1 float-right catalog-step6`} onClick={toggleCatalogView}><i className={`bi ${showCatalogGridView ? 'bi-list' : 'bi-grid'}`}></i></Button>
                    </Nav.Item>
                    <Nav.Item>
                      <Button title="Excel Export" className={`me-1 float-right`} disabled={updatingMCatalogData || exportingData} onClick={() => {if (isGuest) { window.location.href = "/signin"; } else { mcatalogRef.current?.exportData()}}} ><i className={`${exportingData ? 'fa fa-spinner fa-pulse' : 'bi bi-download'}`}></i></Button>
                    </Nav.Item>
                  </>) : ''}
                  {isLeadsView ? (<>
                    {/*
                    <Nav.Item>
                      <Button title="Selected / All" className={`me-1 float-right`} onClick={toggleSelectedOnly}><i className={`bi ${selectedOnly ? 'bi-check-lg' : 'bi-check-all'}`}></i></Button>
                    </Nav.Item>
                    */}
                    <Nav.Item>
                      <Button title="Grid / Cards" className={`me-1 float-right business-step3`} onClick={toggleLeadsView}><i className={`bi ${showLeadsGridView ? 'bi-list' : 'bi-grid'}`}></i></Button>
                    </Nav.Item>
                    <Nav.Item>
                      <Button title="Save List" className={`btn btn-primary mx-1 float-right business-step5`} onClick={() => {if (isGuest) { window.location.href = "/signin"; } else {startSave()}}}><i className={`bi bi-floppy`}></i></Button>
                    </Nav.Item>
                    <Nav.Item>
                        <Button title="Excel Export" className={`btn btn-primary mx-1 float-right`} disabled={exportingLeadsData} onClick={() => {if (isGuest) { window.location.href = "/signin"; } else { exportBusinesses()}}} onContextMenu={exportBusinessesPeople} >
                        <i className={`${exportingLeadsData ? 'fa fa-spinner fa-pulse' : 'bi bi-download'}`}></i>
                      </Button>
                    </Nav.Item>

                  </>) : ''}
                  {isPeopleView ? (<>
                    {/*
                    <Nav.Item>
                      <Button title="Selected / All" className={`me-1 float-right`} onClick={toggleSelectedOnly}><i className={`bi ${selectedOnly ? 'bi-check-lg' : 'bi-check-all'}`}></i></Button>
                    </Nav.Item>
                    */}
                    <Nav.Item>
                      <Button title="Grid / Cards" className={`me-1 float-right`} onClick={togglePeopleView}><i className={`bi ${showPeopleGridView ? 'bi-list' : 'bi-grid'}`}></i></Button>
                    </Nav.Item>
                    <Nav.Item>
                      <Button title="Save List" className={`btn btn-primary mx-1 float-right people-step3`} onClick={() => {if (isGuest) { window.location.href = "/signin"; } else { startSave()}}}><i className={`bi bi-floppy`}></i></Button>
                    </Nav.Item>

                    <Nav.Item>
                          <Button title="Excel Export" className={`btn btn-primary mx-1 float-right`} disabled={exportingPeopleData} onClick={() => {if (isGuest) { window.location.href = "/signin"; } else { exportBusinessesPeople()}}} >
                        <i className={`${exportingPeopleData ? 'fa fa-spinner fa-pulse' : 'bi bi-download'}`}></i>
                      </Button>
                    </Nav.Item>

                  </>) : ''}
                  <Nav.Item>
                    <Button title="Refresh" className={`me-1 float-right catalog-step7`} onClick={tabRefresh}><i className={`bi bi-arrow-repeat`}></i></Button>
                  </Nav.Item>
                </div>
              </Nav>
              <Tab.Content className='m-0 p-0 w-100 h-100' animation="true" mountOnEnter={true} unmountOnExit={true} >
                <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={CATALOG_TAB} title="Catalog">
                  <MCatalog ref={mcatalogRef} loggedInUserPlan={thisProps.plan} loggedInUserId={thisProps.uid} ucountry={thisProps.ucountry} data={updateMCatalogData} country={mcatalogCountry} isucg={isUserCategoryGroup} categorygroup={mcatalogCategoryGroup} category={mcatalogCategory} multipleCategories={mcatalogMultipleCategories} state={mcatalogState} urd={passUpdatingMCatalogData} rcu={passCatalogResultsCount} passExportingData={passExportingData} stl={switchToList} />
                </Tab.Pane>
                <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={LEADS_TAB} title="Businesses">
                  <MLeads ref={mLeadsRef} loggedInUserPlan={thisProps.plan} loggedInUserId={thisProps.uid} loggedInPlanId={thisProps.plid} data={updateMLeadsData} groupByCategory={groupByCategory} catalog={mcatalogData} country={mcatalogCountry} isucg={isUserCategoryGroup} categorygroup={mcatalogCategoryGroup} category={mcatalogCategory} multipleCategories={mcatalogMultipleCategories} state={mcatalogState} kw={leadsKeywords} lfu={updateLeadsFilterModel} rcu={passLeadsResultsCount} urd={passUpdatingMLeadsData} pligs={passLeadsInitialGridState} setExportingLeadsData={setExportingLeadsData} leadsResultsCount={leadsResultsCount} peopleResultsCount={peopleResultsCount} triggerCaptcha={triggerCaptcha}/> {/*  selectedOnly={selectedOnly} ucv={updateCheckValues} */}
                </Tab.Pane>
                <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={PEOPLE_TAB} title="People">
                  <MPeople ref={mPeopleRef} loggedInUserPlan={thisProps.plan} loggedInUserId={thisProps.uid} loggedInPlanId={thisProps.plid} data={updateMPeopleData} groupByCategory={groupByCategory} catalog={mcatalogData} country={mcatalogCountry} isucg={isUserCategoryGroup} categorygroup={mcatalogCategoryGroup} category={mcatalogCategory} multipleCategories={mcatalogMultipleCategories} state={mcatalogState} lfu={updatePeopleFilterModel} rcu={passPeopleResultsCount} urd={passUpdatingMPeopleData} ppigs={passPeopleInitialGridState} setExportingPeopleData={setExportingPeopleData} triggerCaptcha={triggerCaptcha} kw={leadsKeywords}/> {/* selectedOnly={selectedOnly} ucv={updateCheckPeopleValues} */}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
          <div className='d-none d-lg-block col-lg-4 m-0 p-0' style={{ width: "25vw", height: "calc(100% - 43px)" }}>
            <Tab.Container defaultActiveKey={CHARTS_TAB} onSelect={handleDetailsTabSelection} activeKey={activeDetailsTab}>
              <Nav variant='tabs' className='fs-6 border' >
                <Nav.Item><Nav.Link eventKey={CHARTS_TAB} title="Charts">{updatingChartData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse"></i></React.Fragment>) : <i class="bi bi-bar-chart-line"></i>}</Nav.Link></Nav.Item>
                {(isLeadsView || isPeopleView) ? (<>
                  <Nav.Item className='business-step7'><Nav.Link eventKey={DETAILS_TAB} title="Details">{updatingMLeadDetailsData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse"></i></React.Fragment>) : <i class="bi bi-building"></i>}</Nav.Link></Nav.Item>
                  <Nav.Item className='d-none'><Nav.Link eventKey={FACTS_TAB} title="Facts">{updatingMFactsData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse"></i></React.Fragment>) : <i class="bi bi-journal-medical"></i>}</Nav.Link></Nav.Item>
                </>) : ''}
                {isLeadsView && ((props.plid ?? 2) === 1) ? (
                  <Nav.Item><Nav.Link eventKey={PDETAILS_TAB} title="People">{false ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse"></i></React.Fragment>) : <i class="bi bi-people"></i>}</Nav.Link></Nav.Item>
                ) : ''}
              </Nav>
              <Tab.Content className='m-0 p-0 w-100 h-100' animation="true" mountOnEnter={true} unmountOnExit={true} >
                <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={CHARTS_TAB} title="Charts">
                  {isCatalogView ? (
                    <MCharts id="catalog-charts" key={chartKey} mode={CATALOG_TAB} catalog={mcatalogData} groupByCategory={!groupByCategory} country={mcatalogCountry} isucg={isUserCategoryGroup} categorygroup={mcatalogCategoryGroup} category={mcatalogCategory} multipleCategories={mcatalogMultipleCategories} state={mcatalogState} lfu={updateCatalogFilter} ucd={passUpdatingChartData} /> /* selectedOnly={selectedOnly} */
                  ) : ''}
                  {isLeadsView ? (
                    <MCharts id="leads-charts" key={chartKey} mode={LEADS_TAB} catalog={mcatalogData} groupByCategory={groupByCategory} country={mcatalogCountry} isucg={isUserCategoryGroup} categorygroup={mcatalogCategoryGroup} category={mcatalogCategory} multipleCategories={mcatalogMultipleCategories} state={mcatalogState} lfu={updateLeadsFilter} ucd={passUpdatingChartData} filtermodel={leadsFilterModel} /> /* selectedOnly={selectedOnly} */
                  ) : ''}
                  {isPeopleView ? (
                    <MCharts id="people-charts" key={chartKey} mode={PEOPLE_TAB} catalog={mcatalogData} groupByCategory={!groupByCategory} country={mcatalogCountry} isucg={isUserCategoryGroup} categorygroup={mcatalogCategoryGroup} category={mcatalogCategory} multipleCategories={mcatalogMultipleCategories} state={mcatalogState} lfu={updatePeopleFilter} ucd={passUpdatingChartData} filtermodel={peopleFilterModel} /> /* selectedOnly={selectedOnly} */
                  ) : ''}
                </Tab.Pane>
                {isLeadsView || isPeopleView ? (<>
                  <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={DETAILS_TAB} title="Details">
                    <MLeadDetails id="lead-details" mode={isLeadsView ? 'leads' : 'people'} data={isLeadsView ? mleadsData : mPeopleData} urd={passUpdatingMLeadDetailsData} country={mcatalogCountry} userid={thisProps.uid}/>
                  </Tab.Pane>
                  <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={FACTS_TAB} title="Facts">
                    <MFacts id="lead-facts" mode={isLeadsView ? 'leads' : 'people'} data={isLeadsView ? mleadsData : mPeopleData} urd={passUpdatingMFactsData} />
                  </Tab.Pane>
                  <Tab.Pane className='m-0 p-0 w-100 h-100' eventKey={PDETAILS_TAB} title="People">
                    <div className="d-flex align-items-center gap-2 py-2 px-4">
                      <h5 className="mb-0">People</h5>
                      <button className="btn btn-sm btn-success" onClick={handlPeopleAIButton} disabled={people.length > 0}>
                        {isAILoading ? (
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                          'AI-powered Scan'
                        )}
                      </button>
                    </div>
                    <div className="row d-flex m-2">
                      {people && people.length > 0 ? (
                        people.map((person, index) => (
                          <div className="col-md-12 mb-3" key={index} style={{ minWidth: "100px" }}>
                            <div className="card shadow-sm rounded p-3 h-100">
                              <h5 className="mb-1">
                                <i className="fas fa-user-circle me-2"></i>
                                {person.name}
                              </h5>

                              {person.role && (
                                <p className="mb-1">
                                  <i className="fas fa-briefcase me-2 text-secondary"></i>
                                  {person.role}
                                </p>
                              )}

                              {person.company && (
                                <p className="mb-1">
                                  <i className="fas fa-building me-2 text-secondary"></i>
                                  {person.company || mleadsData[0].trimmedname}
                                </p>
                              )}

                              {person.location && (
                                <p className="mb-1">
                                  <i className="fas fa-map-marker-alt me-2 text-secondary"></i>
                                  {person.location || `${mleadsData[0].city}, ${mleadsData[0].state}, ${mleadsData[0].country}`}
                                </p>
                              )}

                              {person.email && (
                                <p className="mb-1">
                                  <i className="fas fa-envelope me-2 text-secondary"></i>
                                  <a href={`mailto:${person.email}`}>{person.email}</a>
                                </p>
                              )}

                              {person.phone && (
                                <p className="mb-0">
                                  <i className="fas fa-phone me-2 text-secondary"></i>
                                  <a href={`tel:${person.phone}`}>{person.phone}</a>
                                </p>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-muted">No People Found</div>
                      )}
                    </div>

                  </Tab.Pane>
                </>) : ''}
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>

      <Modal show={showSaveModal} onHide={cancelSave} centered>
        <Modal.Body className='p-2 shadow'>
          <div className='d-flex flex-column'>
            <Form.Group className="m-3">
              <Form.Label className='fs-6 fw-bold'>List Name</Form.Label>
              <Form.Control
                type='text'
                defaultValue={listName}
                placeholder='List Name'
                autoFocus
                onChange={changeListName}
              />
            </Form.Group>
          </div>
          <div className='p-2 d-flex justify-content-end'>
            <Button className='mx-1' variant="secondary" onClick={cancelSave}>
              Cancel
            </Button>
            <Button className={`mx-1 ${isNewList() ? 'd-flex' : 'd-none'}`} disabled={(listName === '')} variant="primary" onClick={saveNewList}>
              Save New
            </Button>
            <Button className={`mx-1 ${isNewList() ? 'd-none' : 'd-flex'}`} disabled={(listName === '')} variant="primary" onClick={saveList}>
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showCaptcha} centered>
        <Modal.Header>
          <Modal.Title>WowLeads Fair Use Policy</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <p>Dear User,<br/> 
            The millions of business records in WowLeads have been made available to you online for a low flat fee per user. Therefore, we request that the information is accessed on a daily basis under a fair usage policy. Please note that your subscription terms and conditions do not allow the use of any scraping or machine based technology to extract the data for bulk export.
          </p>
          <p className='fw-semibold'>Enter Captcha:</p>
          <Form>
            <div className="mb-3 text-center">
              {captcha && (
                <div
                  dangerouslySetInnerHTML={{ __html: captcha }}
                />
              )}
            </div>

            <InputGroup className="mb-3">
              <Form.Control
                type="text"
                placeholder="Enter the characters"
                value={captchaInput}
                onChange={(e) => setCaptchaInput(e.target.value)}
                required
              />
            </InputGroup>

            {isCaptchaValid === false && (
              <Alert variant="danger" className="py-1">
                Incorrect. Please try again.
              </Alert>
            )}
            {isCaptchaValid === true && (
              <Alert variant="success" className="py-1">
                CAPTCHA passed!
              </Alert>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-between'>
          <div>
            {waitTime !== 0 &&
              (<div>
                Time Remaining: <strong>{waitTime}</strong>
              </div>)
            }
          </div>
          <div className='d-flex gap-2'>
            <Button variant="secondary" onClick={generateCaptcha}>
              Refresh
            </Button>
            <Button variant="primary" onClick={verifyCaptcha} disabled={isCaptchaValid && waitTime !== 0}>
              Verify
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment >
  )
}

export default Mmain;
